import I18n from '../../config/i18n';
import { stringArrayToObject } from '../../utils/array';

import { loadVendors, enableUser, disableUser } from '../../services/DatabaseService';

import { actionCreators as toastActions } from '../Toasts/actions';

export const actions = stringArrayToObject([
  'CLEAR',
  'LOAD_START',
  'LOAD_SUCCESS',
  'LOAD_FAIL',
  'ENABLE_VENDOR',
  'DISABLE_VENDOR',
], '@VENDORS');

const privateActionCreators = {
  loadStart(page, { search }) {
    return {
      type: actions.LOAD_START,
      payload: { page, search },
    };
  },
  loadSuccess({
    vendors, totalPages, total, limit, page,
  }) {
    return {
      type: actions.LOAD_SUCCESS,
      payload: {
        vendors, totalPages, total, limit, page,
      },
    };
  },
  loadFail(error) {
    return {
      type: actions.LOAD_FAIL,
      payload: { error },
    };
  },
};

export const actionCreators = {
  clear() {
    return {
      type: actions.CLEAR,
    };
  },
  load(page = 1, options = {}) {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadStart(page, options));
      const response = await loadVendors(page, options);
      if (response.ok) {
        dispatch(privateActionCreators.loadSuccess(response));
      } else {
        dispatch(privateActionCreators.loadFail(response.error));
      }
    };
  },
  changePagination(limit, { search = null }) {
    return actionCreators.load(1, { limit, search });
  },
  enableVendor(id) {
    return async (dispatch) => {
      dispatch({ type: actions.ENABLE_VENDOR });
      const response = await enableUser(id, 'vendors');
      if (response.ok) {
        dispatch(actionCreators.load());
        dispatch(toastActions.addToast({
          type: 'success',
          message: I18n.t('screens.collaborators.home.messages.enableSuccess'),
        }));
      } else {
        dispatch(toastActions.addToast({
          type: 'error',
          message: I18n.t('screens.collaborators.home.messages.failure'),
        }));
      }
    };
  },
  disableVendor(id) {
    return async (dispatch) => {
      dispatch({ type: actions.DISABLE_VENDOR });
      const response = await disableUser(id, 'vendors');
      if (response.ok) {
        dispatch(actionCreators.clear());
        dispatch(actionCreators.load());
        dispatch(toastActions.addToast({
          type: 'success',
          message: I18n.t('screens.collaborators.home.messages.disableSuccess'),
        }));
      } else {
        dispatch(toastActions.addToast({
          type: 'error',
          message: I18n.t('screens.collaborators.home.messages.failure'),
        }));
      }
    };
  },
};



// WEBPACK FOOTER //
// ./src/redux/Vendors/actions.js